import React from 'react';
import { ButtonProps } from '@guildeducationinc/recess';
import classnames from 'classnames';

type ActionCardButtonsChildren =
  | string
  | React.ReactElement<ButtonProps<any>>
  | React.HTMLProps<HTMLButtonElement | HTMLAnchorElement>;

export interface ActionCardButtonsProps extends React.HTMLAttributes<HTMLElement> {
  testid?: string;
  children: ActionCardButtonsChildren | ActionCardButtonsChildren[];
}

const ActionCardButtons: React.FC<ActionCardButtonsProps> = ({ testid, className, children }) => {
  const classes = classnames(['actionCardButtons', className]);
  return (
    <div data-testid={testid} className={classes}>
      {children}
    </div>
  );
};

export default ActionCardButtons;
